exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app .privacy[data-v-785e73c8]{background:#fff;margin-bottom:3em}#app .privacy h3[data-v-785e73c8]{text-align:center}#app .privacy h4[data-v-785e73c8]{margin-top:2em}#app .privacy[data-v-785e73c8]{text-align:left}.privacy .font-italic[data-v-785e73c8]{font-style:italic}", ""]);

// exports
